// extracted by mini-css-extract-plugin
module.exports = {"desktop-only":"header_desktop-only__DXp_G","mobile-only":"header_mobile-only__0ZpXg"};